import "./BreadcrumbBar.scss";

import { FaChevronRight } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

import type { BreadcrumbItem } from "../../../../contexts/BreadcrumbContext";
import { useBreadcrumbs } from "../../../../contexts/BreadcrumbContext";
// import { useDealPhase } from "../../../../contexts/DealPhaseContext";
// import { dealPhaseOptions } from "../../../../types/config/navConfig";
import { AppRoutes } from "../../../../types/enums/appRoutes";
import { AriaLabel } from "../../../../types/enums/ariaLabels";
// import { LayoutLabel } from "../../../../types/enums/labels";
// import { Select } from "../../../shared";

function BreadcrumbSegment({
  item,
  isLast,
}: {
  item: BreadcrumbItem;
  isLast: boolean;
}) {
  if (isLast) {
    return (
      <span className="app-breadcrumb-bar__current">{item.label}</span>
    );
  }
  const className = "app-breadcrumb-bar__link";
  if (item.to != null) {
    return (
      <Link to={item.to} className={className}>
        {item.label}
      </Link>
    );
  }
  if (item.href != null) {
    return (
      <a
        href={item.href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.label}
      </a>
    );
  }
  return <span>{item.label}</span>;
}

export function BreadcrumbBar() {
  const { pathname } = useLocation();
  const { breadcrumbs } = useBreadcrumbs();
  // const { dealPhase, setDealPhase } = useDealPhase();

  if (pathname === AppRoutes.settings) {
    return null;
  }

  return (
    <div className="app-breadcrumb-bar">
      <div className="app-breadcrumb-bar__row">
        <div className="app-breadcrumb-bar__left">
          {breadcrumbs != null && breadcrumbs.length > 0 ? (
            <nav
              className="app-breadcrumb-bar__nav"
              aria-label={AriaLabel.Breadcrumb}
            >
              <ol className="app-breadcrumb-bar__list">
                {breadcrumbs.map((item, i) => (
                  <li key={i} className="app-breadcrumb-bar__item">
                    {i > 0 && (
                      <FaChevronRight
                        className="app-breadcrumb-bar__sep"
                        aria-hidden
                      />
                    )}
                    <BreadcrumbSegment
                      item={item}
                      isLast={i === breadcrumbs.length - 1}
                    />
                  </li>
                ))}
              </ol>
            </nav>
          ) : null}
        </div>
        {/* Deal Phase selector — hidden until further notice
        <div className="app-breadcrumb-bar__right">
          <label htmlFor="deal-phase-select" className="app-breadcrumb-bar__deal-label">
            {LayoutLabel.DealPhase}
          </label>
          <Select
            id="deal-phase-select"
            options={dealPhaseOptions.map((o) => ({
              value: o.value,
              label: o.label,
            }))}
            value={dealPhase}
            onChange={(value) => setDealPhase(value as typeof dealPhase)}
            placeholder={' '}
            className="app-breadcrumb-bar__select"
          />
        </div>
        */}
      </div>
    </div>
  );
}
